'use client';

import { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { NuqsAdapter as NuqsProvider } from 'nuqs/adapters/next/app';
import { getQueryClient } from 'src/shared/utils/queryClient';

interface IProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: IProvidersProps) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <NuqsProvider>
        <ReactQueryDevtools initialIsOpen={false} />
        {children}
      </NuqsProvider>
    </QueryClientProvider>
  );
}
